module.exports = __webpack_public_path__ + "img/phone-with-shadow.cd50c2fe.png";